import React from "react";
import { Field } from "formik";
import { CurrencyField, RenderField, RenderTypeahead } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";

import Section from "./Section";

import styles from "./Proposal.css";

export const costs = {
  tiAllowance: CurrencyField,
  movingAllowance: CurrencyField,
  legalFee: CurrencyField,
};
const { t } = new Translate("Proposal");

const Costs = ({ dealID, isOpen }) => (
  <Section isOpen={isOpen} title={t("costs")}>
    <div className={styles.container}>
      {Object.keys(costs).map((field, index) => (
        <Field component={costs[field]} key={index} label={t(field)} name={field} />
      ))}
      <div className={styles.fieldGroup}>
        <Field
          component={RenderTypeahead}
          label={t("channelFee")}
          name="channelFeeTitle"
          searchIndex="Channel_by_company"
          searchKey="company"
          searchParameters={{
            facets: "deal_id",
            filters: `deal_id:${dealID}`,
          }}
        />
        <Field component={CurrencyField} name="channelFee" />
      </div>
      <div className={styles.fieldGroup}>
        <Field component={RenderField} label={t("otherCosts")} name="otherCostsTitle" />
        <Field component={CurrencyField} name="otherCosts" />
      </div>
    </div>
  </Section>
);

Costs.propTypes = {
  isOpen: PropTypes.bool,
  dealID: PropTypes.number,
};

export default Costs;
